// Central HTTP wrapper used everywhere in the portal.
//
// Cross-cutting behaviors:
//   - On 401 we wipe the session and bounce to /login?returnTo=<current page>
//     (see utils/session.js) so the user lands back where they were.
//   - 403 handling is centralized in the global fetch interceptor in
//     `src/index.js`. That interceptor only surfaces the friendly
//     "permission denied" modal for *write* methods (POST/PUT/PATCH/
//     DELETE) so background GETs that 403 stay silent. We MUST NOT
//     dispatch the event from here, or every read 403 would also
//     pop the modal on page load.
import { clearRole } from "./permissions";
import i18n from "../translations";
import { redirectToLogin } from "./session";

export const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem("token");

  const response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (response.status === 401) {
    redirectToLogin({ message: i18n.t("session_expired_message"), clearRole });
    return null;
  }

  return response;
};
